/*
 * Photo Cutouts: which ad or link brought an enquirer, for the ES CRM form.
 *
 * Ported from the old theme's es-crm-attribution.js. Same cookies
 * (es_crm_attribution, es_crm_visitor, 90 days) and the same payload keys,
 * so the CRM sees exactly what it saw before. One difference: nothing is
 * stored, and no stored value is read, until the visitor has allowed
 * analytics or marketing through Shopify's own consent banner
 * (window.Shopify.customerPrivacy). Without that consent the form still
 * sends, carrying only the current page's address, referrer and campaign
 * codes (utm_*, gclid, fbclid, msclkid, ttclid), and no visitor id.
 *
 * Loaded on every page from snippets/pco-head.liquid, so with consent the page
 * a visitor first landed on is the one recorded, not the contact page.
 */
(function () {
  if (window.esCrmAttribution) return;
  var COOKIE_ATTR = 'es_crm_attribution';
  var VISITOR_COOKIE = 'es_crm_visitor';
  var MAX_AGE = 60 * 60 * 24 * 90;
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid', 'msclkid', 'ttclid'];

  function privacy() {
    return (window.Shopify && window.Shopify.customerPrivacy) || null;
  }

  /* True only when Shopify's consent API is loaded and says yes. */
  function consented() {
    var cp = privacy();
    if (!cp) return false;
    try {
      var marketing = typeof cp.marketingAllowed === 'function' && cp.marketingAllowed();
      var analytics = typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed();
      return Boolean(marketing || analytics);
    } catch (e) {
      return false;
    }
  }

  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    if (!match) return null;
    try {
      return JSON.parse(decodeURIComponent(match[1]));
    } catch (e) {
      return null;
    }
  }

  function writeCookie(name, data) {
    document.cookie =
      name + '=' + encodeURIComponent(JSON.stringify(data)) + '; path=/; max-age=' + MAX_AGE + '; SameSite=Lax';
  }

  /* What this page alone says: its address, referrer and campaign codes. */
  function fromThisPage() {
    var params = new URLSearchParams(window.location.search);
    var found = {};
    KEYS.forEach(function (key) {
      var value = params.get(key);
      if (value) found[key] = value;
    });
    found.landing_page_url = window.location.href;
    if (document.referrer) found.referrer_url = document.referrer;
    return found;
  }

  /* With consent: first touch wins, as before. Stores and returns the cookie. */
  function captureStored() {
    var page = fromThisPage();
    var stored = readCookie(COOKIE_ATTR) || {};
    var changed = false;
    KEYS.concat(['landing_page_url', 'referrer_url']).forEach(function (key) {
      if (page[key] && !stored[key]) {
        stored[key] = page[key];
        changed = true;
      }
    });
    if (changed) writeCookie(COOKIE_ATTR, stored);
    return stored;
  }

  function visitorId() {
    var stored = readCookie(VISITOR_COOKIE);
    if (stored && stored.id) return stored.id;
    var id =
      typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : 'v-' + Date.now() + '-' + Math.random().toString(16).slice(2);
    writeCookie(VISITOR_COOKIE, { id: id });
    return id;
  }

  function current() {
    return consented() ? captureStored() : fromThisPage();
  }

  function applyToPayload(payload) {
    var allowed = consented();
    var attrs = allowed ? captureStored() : fromThisPage();
    var given = payload.fields || {};
    var fields = Object.assign({}, given, {
      gclid: given.gclid || attrs.gclid,
      fbclid: given.fbclid || attrs.fbclid,
      msclkid: given.msclkid || attrs.msclkid,
      ttclid: given.ttclid || attrs.ttclid,
    });
    var out = Object.assign({}, payload, {
      landing_page_url: payload.landing_page_url || attrs.landing_page_url,
      referrer_url: payload.referrer_url || attrs.referrer_url,
      utm_source: payload.utm_source || attrs.utm_source,
      utm_medium: payload.utm_medium || attrs.utm_medium,
      utm_campaign: payload.utm_campaign || attrs.utm_campaign,
      utm_content: payload.utm_content || attrs.utm_content,
      utm_term: payload.utm_term || attrs.utm_term,
      fields: fields,
    });
    if (allowed) out.visitor_id = visitorId();
    return out;
  }

  /* Record the landing page as soon as consent exists: now, or when given. */
  function onConsent() {
    if (consented()) captureStored();
  }

  document.addEventListener('visitorConsentCollected', onConsent);

  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error) onConsent();
    });
  }

  window.esCrmAttribution = {
    get: current,
    consented: consented,
    applyToFormPayload: applyToPayload,
  };
})();
